import { CAR_BATTERY_VEHICLE_TYPE_ID, MOTOR_BATTERY_VEHICLE_TYPE_ID } from '@/constants/batteryProduct';

export const batteryRequestSteps = [
    { id: 'select', title: 'ماشین و باتری' },
    { id: 'reservation', title: 'زمان نصب' },
    { id: 'address', title: 'آدرس' },
    { id: 'services', title: 'خدمات اضافی' },
    { id: 'payment', title: 'پرداخت' }
] as const;

export const BATTERY_REQUEST_STEP = {
    select: 1,
    reservation: 2,
    address: 3,
    services: 4,
    payment: 5
} as const;

export const BATTERY_PAYMENT_PRICE_NOTE =
    'قیمت این سفارش با فرض تحویل باتری قدیمی هم‌آمپر محاسبه شده است. اگر آمپر باتری قدیمی کمتر باشد یا باتری قدیمی نداشته باشید، مابه‌التفاوت جداگانه محاسبه می‌شود و اگر بیشتر باشد به کیف پول شما برمی‌گردد.';

export const batteryQuickVehicleKeywords = [
    'پژو ۴۰۵',
    'پراید',
    'کوییک',
    'پژو ۲۰۶',
    'سمند',
    'پرادو',
    'دنا',
    'تویوتا',
    'تیگو',
    'ساینا',
    'پژو ۲۰۷',
    'رانا',
    'هیوندای',
    'کیا سراتو'
];

export const motorBatteryQuickVehicleKeywords = ['هوندا کلیک', 'طرح کلیک', 'بنلی', 'یاماها', 'طرح آیروکس', 'وسپا', 'آپاچی'];

export const batteryQuickKeywordsHint = {
    [CAR_BATTERY_VEHICLE_TYPE_ID]: 'ماشینت این‌جا نیست؟ برند یا مدلش رو بالا جستجو کن.',
    [MOTOR_BATTERY_VEHICLE_TYPE_ID]: 'موتورت این‌جا نیست؟ برند یا مدلش رو بالا جستجو کن.'
};

export const batteryQuickVehicleKeywordsByType = {
    [CAR_BATTERY_VEHICLE_TYPE_ID]: batteryQuickVehicleKeywords,
    [MOTOR_BATTERY_VEHICLE_TYPE_ID]: motorBatteryQuickVehicleKeywords
};

export const BATTERY_OLD_BATTERY_PRICE_HINT = 'قیمت‌ها برای تعویض با باتری قدیمی هم‌آمپر است.';
